import React from 'react';
import { Svg } from '../Svg/Svg';

interface IconTextProps {
  className?: string;
  textClassName?: string;
  label: string | React.ReactNode;
  iconSize?: number;
  iconColour?: string;
  iconType: string;
  iconRotation?: string;
  iconTop?: string;
}

const IconText: React.FC<IconTextProps> = ({
  className = '',
  textClassName = '',
  label,
  iconSize = 1,
  iconColour = 'black',
  iconType,
  iconRotation,
  iconTop,
}) => {
  return (
    <div className={`mz-icon-text ${className}`}>
      <Svg
        size={iconSize}
        colour={iconColour}
        type={iconType}
        rotation={iconRotation}
        style={{ top: iconTop }}
      />
      <div className={`mz-icon-text-text ${textClassName}`}>{label}</div>
    </div>
  );
};

export default IconText;
